function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#77A0C5",
    fillOpacity: 0.4,
    style: {
      fill: "#77A0C5",
      fill: "color(display-p3 0.4667 0.6275 0.7725)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7882 22.5H24.1872C24.3563 22.5 24.5 22.353 24.5 22.1736V11.8264C24.5 11.65 24.3591 11.5 24.1872 11.5H8.81638C8.64731 11.5 8.50361 11.647 8.50361 11.8264V22.1736C8.47543 22.353 8.61632 22.5 8.7882 22.5ZM23.8463 21.8472H9.10097V12.1528H23.8463V21.8472Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.676 15.8383H21.1789C21.3506 15.8383 21.4913 15.6746 21.4913 15.4748V11.6096C21.4913 11.413 21.3506 11.246 21.1789 11.246H19.676C19.5043 11.246 19.3636 11.4097 19.3636 11.6096V15.442C19.3636 15.6746 19.5043 15.8383 19.676 15.8383ZM20.8665 15.0784H20.0166V11.9732H20.8665V15.0784Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7937 22.5H21.2063C21.3677 22.5 21.5 22.3668 21.5 22.2044V18.7956C21.5 18.6358 21.3677 18.5 21.2063 18.5H19.7937C19.6323 18.5 19.5 18.6332 19.5 18.7956V22.2044C19.5 22.3668 19.6323 22.5 19.7937 22.5ZM20.9127 21.9088H20.1138V19.0886H20.9127V21.9088Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8715 15.8383H13.3744C13.5433 15.8383 13.6868 15.6746 13.6868 15.4748V11.6096C13.6868 11.413 13.5461 11.246 13.3744 11.246H11.8715C11.6998 11.246 11.5591 11.4097 11.5591 11.6096V15.442C11.5591 15.6746 11.6998 15.8383 11.8715 15.8383ZM13.0648 15.0784H12.2149V11.9732H13.0648V15.0784Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7937 22.5H13.2063C13.3651 22.5 13.5 22.3668 13.5 22.2044V18.7956C13.5 18.6358 13.3677 18.5 13.2063 18.5H11.7937C11.6323 18.5 11.5 18.6332 11.5 18.7956V22.2044C11.5 22.3668 11.6323 22.5 11.7937 22.5ZM12.9153 21.9088H12.1164V19.0886H12.9153V21.9088Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6898 17.5907H19.4228L21.5224 17.558H21.5505C22.3442 17.4269 23.0816 17.0633 23.5938 16.5327C24.1623 15.9398 24.4747 15.2126 24.4747 14.4527V11.6455C24.4747 11.449 24.334 11.2819 24.1623 11.2819H8.81237C8.64351 11.2819 8.49997 11.4457 8.49997 11.6455V14.4527C8.49997 15.1799 8.78423 15.9071 9.29364 16.4672C9.77491 16.9946 10.456 17.3909 11.2244 17.5252C11.3369 17.558 11.4523 17.558 11.5367 17.5907H13.6926H13.6898ZM19.42 16.8308H13.687L11.5874 16.798C11.503 16.798 11.4157 16.7653 11.3032 16.7653C10.0254 16.4999 9.11915 15.5107 9.11915 14.4199V12.0091H23.8471V14.4199C23.8471 15.5762 22.8255 16.5982 21.4914 16.798L19.42 16.8308Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3917 19.3071H21.4913C21.663 19.3071 21.8037 19.1433 21.8037 18.9435V15.4419C21.8037 15.2454 21.663 15.0783 21.4913 15.0783H19.3917C19.2229 15.0783 19.0793 15.2421 19.0793 15.4419V18.9435C19.0512 19.1433 19.1919 19.3071 19.3917 19.3071ZM21.1508 18.5799H19.7041V15.8382H21.1508V18.5799Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5901 19.3071H13.6897C13.8585 19.3071 14.0021 19.1433 14.0021 18.9435V15.4419C14.0021 15.2454 13.8614 15.0783 13.6897 15.0783H11.5901C11.4184 15.0783 11.2777 15.2421 11.2777 15.4419V18.9435C11.2495 19.1433 11.3903 19.3071 11.5901 19.3071ZM13.3491 18.5799H11.9025V15.8382H13.3491V18.5799Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6899 11.9764H19.3948C19.5665 11.9764 19.7072 11.8126 19.7072 11.6128V9.8636C19.7072 9.66378 19.5665 9.5 19.3948 9.5H13.6899C13.5183 9.5 13.3775 9.66378 13.3775 9.8636V11.6128C13.3494 11.8126 13.4901 11.9764 13.6899 11.9764ZM19.0514 11.2492H13.9995V10.2599H19.0514V11.2492Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5765 19.9983H18.1732V20.6927H17.5765V19.9983Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6675 19.9983H17.2642V20.6927H16.6675V19.9983Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7865 19.9983H16.3831V20.6927H15.7865V19.9983Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8802 19.9983H15.4769V20.6927H14.8802V19.9983Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.7e3944e35dabd6fdd1c9e9689e330a40.svg";
export { ForwardRef as ReactComponent };